type useHistoryCheckModalProps = {
  adId: string;
  callbackUrl: string;
};

export const HISTORY_CHECK_REPORT = {
  COMPLETE_REPORT: 'COMPLETE_REPORT',
  STANDALONE_COMPLETE_REPORT: 'STANDALONE_COMPLETE_REPORT',
} as const;

export type { useHistoryCheckModalProps };
